"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Race = void 0;
const react_1 = __importStar(require("react"));
const monace_1 = require("@cs125/monace");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Ace_1 = require("../react-ace/Ace");
const useStyles = makeStyles_1.default(theme => ({
    player: {
        width: "100%",
        height: theme.spacing(4),
    },
}));
exports.Race = props => {
    const classes = useStyles();
    const [replaying, setReplaying] = react_1.useState(false);
    const [trace, setTrace] = react_1.useState();
    const [output, setOutput] = react_1.useState();
    const [showOutput, setShowOutput] = react_1.useState();
    const editor = react_1.useRef();
    const audioPlayer = react_1.useRef(null);
    const playingTrace = react_1.useRef(undefined);
    const startTrace = react_1.useCallback(trace => {
        if (!audioPlayer.current || !editor.current || !trace) {
            return;
        }
        playingTrace.current && playingTrace.current.stop();
        playingTrace.current = monace_1.replay(editor.current, trace.editorTrace, {
            start: Math.round(audioPlayer.current.currentTime * 1000),
            onExternalChange: (externalChange) => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { type, timestamp, ...change } = externalChange;
                Ace_1.AceChanges.check(change);
                if (Ace_1.AceOutputChange.guard(change)) {
                    setOutput(change.output);
                }
                else if (Ace_1.AceShowOutputChange.guard(change)) {
                    setShowOutput(change.state === "open");
                }
            },
        });
        setReplaying(true);
    }, []);
    const stopTrace = react_1.useCallback(() => {
        playingTrace.current && playingTrace.current.stop();
        setShowOutput(undefined);
        setOutput(undefined);
        setReplaying(false);
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Ace_1.Ace, Object.assign({}, props, { output: output, showOutput: showOutput, onRecordComplete: t => setTrace(t), onLoad: e => {
                editor.current = e;
            }, replaying: replaying })),
        trace && (react_1.default.createElement("audio", { ref: audioPlayer, className: classes.player, controls: true, src: trace.audioUrl, onPlay: () => startTrace(trace), onEnded: stopTrace, onPause: stopTrace }))));
};
//# sourceMappingURL=Race.js.map